'use client';
import React, { useEffect, useRef, useState } from 'react';

export default function StickyCtaBar() {
  const [visible, setVisible] = useState(false);
  const sentinelRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    // Activate after first testimonial enters viewport
    const sentinel = document.querySelector('.testimonial-tile');
    if (!sentinel) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) setVisible(true);
      },
      { threshold: 0.3 }
    );
    observer?.observe(sentinel);
    return () => observer?.disconnect();
  }, []);

  const scrollToForm = () => {
    document.getElementById('consultation-form')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <>
      {/* Sentinel */}
      <div ref={sentinelRef} />
      {/* Bar */}
      <div
        id="sticky-cta"
        className={`fixed bottom-0 left-0 right-0 z-50 ${visible ? 'visible' : ''}`}
        style={{
          background: 'linear-gradient(90deg, #0B1D3A 0%, #0E2347 100%)',
          borderTop: '1px solid rgba(184,148,62,0.3)',
        }}
      >
        <div className="max-w-6xl mx-auto px-6 py-3.5 flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-4">
            <div
              className="w-2 h-2 rounded-full animate-pulse"
              style={{ background: '#8B2D2D' }}
            />
            <p className="text-[11px] font-medium tracking-wider text-marble/70">
              <span className="text-gold font-semibold">Statute partners</span> are available for urgent regulatory matters —{' '}
              <span className="text-marble/50">response within 2 hours</span>
            </p>
          </div>
          <button
            onClick={scrollToForm}
            className="btn-red px-7 py-2.5 text-[10px] font-semibold tracking-widest uppercase rounded-sm flex-shrink-0"
          >
            Request a Confidential Consultation
          </button>
        </div>
      </div>
    </>
  );
}